export default __webpack_public_path__ + "static/media/a99959a6691acd9cebcf317bab848175.png";